import { createInertiaApp } from '@inertiajs/vue3';
import axios from 'axios';
import get from 'lodash/get';
import { createApp, h } from 'vue';
import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.interceptors.response.use(
    (response) => response,
    async (err) => {
        const status = get(err, 'response.status');

        if (status === 419) {
            console.log(
                'CSRF token expired. Refreshing token and retrying request...',
            );

            await axios.get('/csrf-token');

            return axios(err.response.config);
        }

        return Promise.reject(err);
    },
);

window.moment = require('moment');

createInertiaApp({
    resolve: (name) => require(`./${name}`),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(Vue3Toastify, {
                position: 'top-right',
                autoClose: 3000,
            });

        app.config.globalProperties.$active_route = (activeRoute) => {
            return activeRoute === route().current();
        };

        app.config.globalProperties.route = (name, options) =>
            route(name, options);

        app.config.globalProperties.axios = axios;

        app.mount(el);

        return { app };
    },
    progress: {
        color: '#4D65B9',
    },
    inject: true,
});
